/**
 * Pure lifecycle values + tone (no data imports), so UI that only needs the
 * colour — e.g. the status guide — never pulls the Supabase client into its
 * module tree. customerLifecycle.js re-exports both.
 */

export const POOL_LIFECYCLE_VALUES = ['opening', 'active', 'closing', 'closed', 'inactive'];

/** Tone for lifecycle DotText (RD-UI-030). Inactive/closed are gray; closing is info. */
export function poolLifecycleTone(lifecycleStatus) {
  const s = lifecycleStatus ?? 'active';
  if (s === 'opening' || s === 'closing') return 'info';
  if (s === 'active') return 'success';
  return 'neutral'; // closed | inactive | unknown
}
